module.exports = __webpack_public_path__ + "static/media/peanut-free.c53c2402.png";